import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UiChangesPreventionDialogComponent } from './modals/ui-changes-prevention-dialog/ui-changes-prevention-dialog.component';
import { TreeModule } from '@circlon/angular-tree-component';
import { MatDialogModule } from '@angular/material/dialog';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DigitalFilesComponent } from './components/digital-files/digital-files.component';
import { ProductSetupProductTabComponent } from './components/product-setup-product-tab/product-setup-product-tab.component';
import { MarketingDetailsComponent } from './components/product-setup-product-tab/marketing-details/marketing-details.component';
import { RedemptionDetailsComponent } from './components/product-setup-product-tab/redemption-details/redemption-details.component';
import { MessageFilterPipe } from './pipes/message-filter.pipe';
import { TooltipListPipe } from './pipes/tooltip-list.pipe';
import { MaxImageSizeModalComponent } from './modals/max-image-size-modal/max-image-size-modal.component';
import { InvalidUploadFileTypeModalComponent } from './modals/invalid-upload-file-type-modal/invalid-upload-file-type-modal.component';
import { ConvertBytesPipe } from './pipes/convert-bytes.pipe';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from 'primeng/editor';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ListboxModule } from 'primeng/listbox';
import { GroupFieldCheckPipe } from './pipes/group-field-check.pipe';
import { GroupMarketingDetailsComponent } from './components/product-setup-product-tab/group-marketing-details/group-marketing-details.component';
import { GroupRedemptionDetailsComponent } from './components/product-setup-product-tab/group-redemption-details/group-redemption-details.component';
import { SubmitRequestDialogComponent } from './modals/submit-request-dialog/submit-request-dialog.component';
import {PrimeEditorComponent} from './components/prime-editor/prime-editor.component';

const SHARED_MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  MatDialogModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatTableModule,
  MatCheckboxModule,
  MatInputModule,
  MatFormFieldModule,
  MatSortModule,
  MatAutocompleteModule,
  MatSnackBarModule,
  NgxDropzoneModule,
  TreeModule,
  ReactiveFormsModule,
  ImageCropperModule,
  TabViewModule,
  EditorModule,
  ToggleButtonModule,
  ListboxModule
];

const SHARED_COMPONENTS = [
  UiChangesPreventionDialogComponent,
  DigitalFilesComponent,
  ProductSetupProductTabComponent,
  MarketingDetailsComponent,
  GroupMarketingDetailsComponent,
  GroupRedemptionDetailsComponent,
  RedemptionDetailsComponent,
  MaxImageSizeModalComponent,
  InvalidUploadFileTypeModalComponent,
  SubmitRequestDialogComponent,
  PrimeEditorComponent
];

const SHARED_PIPES = [
  SafeHtmlPipe,
  MessageFilterPipe,
  TooltipListPipe,
  ConvertBytesPipe,
  GroupFieldCheckPipe
];

const SHARED_DIRECTIVES = [
];

@NgModule({
    imports: [
      ...SHARED_MODULES,
    ],
  declarations: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES,
  ],

  exports: [
    ...SHARED_MODULES,
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES,
  ]
})

export class SharedModule {
}
